interface KeyDatesCardProps {
  startDate: string;
  estimatedEndDate: string;
  actualEndDate?: string;
}

export const KeyDatesCard = ({ startDate, estimatedEndDate, actualEndDate }: KeyDatesCardProps) => {
  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString('en-CA', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const calculateDuration = () => {
    const start = new Date(startDate);
    const end = actualEndDate ? new Date(actualEndDate) : new Date(estimatedEndDate);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} days`;
  };

  return (
    <div className="bg-white p-3.5 rounded-xl border border-gray-200">
      <h3 className="text-sm font-bold text-gray-900 mb-2">Key Dates</h3>
      <div className="space-y-2 text-sm text-gray-600">
        <p className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base">play_arrow</span>
          Start Date: {formatDate(startDate)}
        </p>
        <p className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base">flag</span>
          Estimated End: {formatDate(estimatedEndDate)}
        </p>
        {actualEndDate && (
          <p className="flex items-center gap-2">
            <span className="material-symbols-outlined text-base">check_circle</span>
            Actual End: {formatDate(actualEndDate)}
          </p>
        )}
        <p className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base">schedule</span>
          Duration: {calculateDuration()}
        </p>
      </div>
    </div>
  );
};


